import { Component } from '@angular/core';
import { Router } from '@angular/router';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'iq-central-front-end-certificate',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.scss'],
})
export class CertificateComponent {
  isLoading: boolean = false;
  certificateData: {
    fullName: string;
    courseCode: string;
    courseName: string;
    issuedDate: string;
    certificateId: string;
    subjectArea: string;
  };

  constructor(private readonly router: Router) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.certificateData = navigation?.extras.state as {
        fullName: string;
        courseCode: string;
        courseName: string;
        issuedDate: string;
        certificateId: string;
        subjectArea: string;
      };
    } else {
      const savedData = localStorage.getItem('certificateData');
      if (savedData) {
        this.certificateData = JSON.parse(savedData);
      }
    }
  }

  async downloadCertificate() {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;

    try {
      const certificate = document.getElementById('certificate');
      if (!certificate) {
        return;
      }

      // Get the dimensions of the element
      const { width, height } = certificate.getBoundingClientRect();

      // Create canvas with better resolution
      const canvas = await html2canvas(certificate, {
        scale: 2, // Better quality
        useCORS: true, // Allow images from other domains
        logging: false,
        allowTaint: true,
      });

      // Calculate PDF dimensions (maintain aspect ratio)
      const orientation = width > height ? 'landscape' : 'portrait';
      const pdf = new jsPDF(orientation, 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const aspectRatio = width / height;

      let imgWidth = pdfWidth - 20; // 10mm margin on each side
      let imgHeight = imgWidth / aspectRatio;

      // Ensure it fits within the page
      if (imgHeight > pdfHeight - 20) {
        imgHeight = pdfHeight - 20;
        imgWidth = imgHeight * aspectRatio;
      }

      // Center the image on the page
      const x = (pdfWidth - imgWidth) / 2;
      const y = (pdfHeight - imgHeight) / 2;

      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);
      pdf.save('certificate.pdf');
      this.isLoading = false;
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  }
}
